import { clsx } from 'clsx';
import { Create, CreateProps } from 'react-admin';

import { Forbidden } from '@components';
import { useCreateProps, useRbacCreate } from '@hooks';
import { ProductForm } from '@pages/product/ProductForm';
import cls from '../ProductForm/ProductForm.module.css';


export const ProductCreate = (props: CreateProps) => {
  const createProps = useCreateProps();
  const rbacCreate = useRbacCreate();

  if (!rbacCreate) {
    return <Forbidden />;
  }

  return (
    <Create {...props} {...createProps} className={clsx(cls.page, 'details-page-wrapper')}>
      <ProductForm />
    </Create>
  );
};
